export const RESUME_FORM_DATE_FIELD_UPDATE = "RESUME_FORM_DATE_FIELD_UPDATE";
export const RESUME_FORM_DEFAULT = "RESUME_FORM_DEFAULT";
export const RESUME_FORM_SUBMIT = "RESUME_FORM_SUBMIT";
export const RESUME_FORM_SUBMIT_SUCCESS = "RESUME_FORM_SUBMIT_SUCCESS";